<template>
  <section>
    <!-- Listing Header -->
    <organization-header
      @search="search"
      @add="addOrganization"
      @delete="deleteOrganization"
      @activate="activateOrganization"
    />
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="organizationList"
        sortBy="id"
        orderBy="asc"
        :columns="tableColumns"
        :isSingleRowDetail="true"
        @sort="setOrder"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
      >
        <template v-slot:tbody="props">
          <th scope="row" class="z-column-80">{{ props.row.id }}</th>
          <td class="z-column-60-center">
            <a href="#" @click="editOrganization(props.row)">edit</a>
          </td>
          <td class="z-column-80-center">
            <!-- <breeze-nav-link :href="route('usercardiomanage')" class="nav-link">
              manage
            </breeze-nav-link> -->
            <a href="#" @click="manageOrganization(props.row)">coach</a>
          </td>
          <td>{{ props.row.orgCode }}</td>
          <td>{{ props.row.orgName }}</td>
          <td
            v-if="isFeatureAllowed('organization_removal')"
            class="z-column-60-center"
          >
            <a href="#" @click="deleteOrganization(props.row)">remove</a>
          </td>
        </template>
        <template v-slot:detail="props">
          <organization-record :recordData="props.row" />
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <organization-dialog
      id="organization-modal"
      :show="actionOrganization"
      @close="closeModal"
      @saved="savedOrganization"
    />
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BreezeNavLink from '@/Components/Elements/NavLink'
import ZTable from '@/Components/ZElements/Table'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import OrganizationHeader from '@/Components/Organizations/organization-header'
import OrganizationDialog from '@/Components/Organizations/forms/organization-dialog'
import OrganizationRecord from '@/Components/Organizations/organization-record'
export default {
  name: 'organization-listing',
  components: {
    BreezeNavLink,
    ZTable,
    OrganizationHeader,
    OrganizationDialog,
    OrganizationRecord,
    ConfirmRemove,
  },
  data() {
    return {
      page: 1,
      actionOrganization: null,
      currentId: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove:
        'Are you sure you wish to <b>remove</b> this Organization?</br>This <b>cannot be undone</b> and all related data will be <u>lost</u>.',
      actionConfirmRemove: null,
    }
  },
  async mounted() {
    this.currentId = null
    await this.getStateProvinces()
    await this.getTimezones()
    await this.getTags()
    await this.search()
  },
  computed: {
    ...mapGetters('users', ['isFeatureAllowed']),
    ...mapGetters('organizations', ['organizations', 'organization', 'pager']),
    tableColumns() {
      let columns = [
        {
          field: 'id',
          label: 'Id',
          sortable: true,
          class: 'z-column-80',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-80-center',
        },
        { field: 'orgCode', label: 'Group Code', sortable: true },
        { field: 'orgName', label: 'Name', sortable: true },
      ]
      if (this.isFeatureAllowed('organization_removal')) {
        columns.push({
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        })
      }
      return columns
    },
    organizationList() {
      let _organizations = []
      if (this.organizations) {
        _organizations = JSON.parse(JSON.stringify(this.organizations))
        _organizations.forEach((organization) => {
          organization.isDetailVisible = false
        })
      }
      return _organizations
    },
  },
  methods: {
    ...mapActions('configuration', ['getStateProvinces', 'getTimezones']),
    ...mapActions('organizations', [
      'getOrganizations',
      'getOrganization',
      'getOrganizationHighlight',
      'setPager',
      'resetOrganization',
      'examineOrganization',
      'removeOrganization',
      'getTags',
    ]),
    ...mapActions('global', ['setLoading']),
    ...mapActions('usercardio', {
      setCardioPager: 'setPager',
      setFilter: 'setFilter',
      setChecked: 'setChecked',
    }),
    async search() {
      try {
        console.log('getOrganizations', this.pager)
        await this.getOrganizations({
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
        })
        window.app.$forceUpdate()
      } catch (e) {
        console.log('Error', e)
      }
    },
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    closeModal() {
      this.actionOrganization = null
      this.actionConfirmRemove = null
    },
    async savedOrganization(data) {
      await this.search()
      if (this.actionOrganization) {
        if (this.actionOrganization.isAdd) {
          await this.editOrganization(data)
        }
        this.actionOrganization.isAdd = false
      }
    },
    async addOrganization() {
      this.resetOrganization()
      this.actionOrganization = {
        isAdd: true,
        cameFrom: 1,
        data: null,
      }
    },
    async editOrganization(data) {
      this.setLoading(true)
      this.examineOrganization({
        id: data.id,
        name: data.orgName,
      })
      await this.getOrganization(data.id)
      this.isAdd = false
      this.actionOrganization = {
        isAdd: false,
        cameFrom: 1,
        data: data,
      }
      this.setLoading(false)
    },
    manageOrganization(row) {
      this.setCardioPager({
        name: 'search',
        value: '',
      })
      this.setCardioPager({
        name: 'page',
        value: 1,
      })
      this.setFilter({
        name: 'filterAs',
        value: null,
      })
      this.setFilter({
        name: 'range-limit',
        value: null,
      })
      this.setFilter({
        name: 'range-min',
        value: null,
      })
      this.setFilter({
        name: 'range-max',
        value: null,
      })
      this.setChecked({
        action: 'reset',
        checked: false,
      })
      this.examineOrganization({
        id: row.id,
        name: row.orgName,
        isBatchIntel: row.isBatchIntel,
      })
      let url = route('usercardio-manage', row.id)
      window.location = url
    },
    activateOrganization() {},
    deleteOrganization(row) {
      this.currentId = row.id
      this.actionConfirmRemove = true
    },
    performRemove() {
      this.removeOrganization(this.currentId)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
